import ListItem from '@mui/material/ListItem';
import type { GroupedOrderProduct } from '@witmetrics/utils';
import { useLabCurrency, useProduct } from '@witmetrics/data-store';
import { formatPrice } from '@witmetrics/utils/strings';
import { isEmpty } from '@witmetrics/utils/misc';
import IconButton from '@/components/IconButton';
import { DeleteIcon } from '@/icons';
import TextField from '@/components/inputs/TextField';
import { classes } from './utils';

export type OrderListItemProps = {
  labId: number;
  groupedProduct: GroupedOrderProduct;
  onChange: (product: GroupedOrderProduct) => void;
  onRemove: () => void;
};

export default function OrderListItem({
  labId,
  groupedProduct,
  onChange,
  onRemove,
}: OrderListItemProps) {
  const currency = useLabCurrency(labId);
  const product = useProduct(groupedProduct.productId);

  const handleQuantityChange = (newQuantity: string) => {
    onChange({
      ...groupedProduct,
      quantity: isEmpty(newQuantity) ? 0 : Math.min(parseInt(newQuantity), 100),
    });
  };

  if (!product) return null;

  const { quantity, price } = groupedProduct;

  return (
    <>
      <ListItem className={classes.listItem}>
        <div className={classes.leftContent}>
          <TextField
            className={classes.quantity}
            size="small"
            type="number"
            label="Qty."
            InputProps={{ inputProps: { min: 1, max: 100 } }}
            value={quantity !== null && quantity !== 0 ? `${quantity}` : ''}
            onChange={handleQuantityChange}
          />
          <div className={classes.details}>
            <div className={classes.name}>{product.name}</div>
            <div className={classes.price}>
              {formatPrice(parseFloat(price), currency)}
            </div>
          </div>
        </div>
        <div className={classes.rightContent}>
          <div className={classes.total}>
            {formatPrice(quantity * parseFloat(price), currency)}
          </div>
          <IconButton
            className={classes.iconButton}
            size="small"
            onClick={onRemove}>
            <DeleteIcon />
          </IconButton>
        </div>
      </ListItem>
    </>
  );
}
